import React, { useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { Field } from 'redux-form'
import { COLORES } from '../../../../config/colores'
import { renderTextField } from '../../../Forms/fieldRenderers'
import CampoExportadorRemito from './CampoExportadorRemito'
import CampoPlantaRemito from './CampoPlantaRemito'

function CampoRemito (props) {
  const { planta, exportador } = props
  const [showOtraPlanta, setShowOtraPlanta] = useState(false)
  const disabled = (planta === '' && !showOtraPlanta)

  return (
    <Row>
      <Col md={12}>
        <h4>Peso bruto con remito</h4>
        <p>Seleccione la <b>planta</b> de origen e ingrese el <b>número de remito</b> </p>
      </Col>

      <Col md={9}>
        <CampoExportadorRemito exportador={exportador} />
        <CampoPlantaRemito planta={planta} resetPlanta={props.resetPlanta} setShowOtraPlanta={setShowOtraPlanta} />
      </Col>

      <Col
        md={3}
        style={{
          display: 'flex',
          alignItems: 'center',
          borderRadius: '22px',
          padding: '2%',
          justifyContent: 'center',
          backgroundColor: COLORES.grey.dark,
          color: 'white'
        }}
      >
        {planta !== ''
          ? <Field
            name='numero'
            type='text'
            label='Número de remito'
            component={renderTextField}
            style={{ fontSize: '2rem', textAlign: 'center', color: COLORES.grey.dark }}
            autoFocus={!showOtraPlanta}
            maxLength={12}
            disabled={disabled}
            placeholder='0102000000'
          />
          : <p><b> Seleccione la planta para poder ingresar el número de remito </b></p>
        }
      </Col>
    </Row>
  )
}

export default CampoRemito
